export var PermissionType;
(function (PermissionType) {
    PermissionType["PermissionIdUnspecified"] = "permission_id_unspecified";
    PermissionType["GlobalSettingsView"] = "global_settings.view";
    PermissionType["VaultAccountsManage"] = "vault_accounts.manage";
    PermissionType["CostExplorerView"] = "cost_explorer.view";
    PermissionType["UserAccessManage"] = "user_access.manage";
    PermissionType["SamlGroupAccessManage"] = "saml_group_access.manage";
    PermissionType["ApiCredentialsManage"] = "api_credentials.manage";
    PermissionType["ApiCredentialsRotateSecret"] = "api_credentials.rotate_secret";
    PermissionType["CustomRolesManage"] = "custom_roles.manage";
    PermissionType["DashboardView"] = "dashboard.view";
    PermissionType["InventoryView"] = "inventory.view";
    PermissionType["JobsView"] = "jobs.view";
    PermissionType["AuditLogsView"] = "audit_logs.view";
    PermissionType["BackupSettingsView"] = "backup_settings.view";
    PermissionType["StorageGatewayView"] = "storage_gateway.view";
    PermissionType["DatabaseExplorerSearch"] = "database_explorer.search";
    PermissionType["FileExplorerSearch"] = "file_explorer.search";
    PermissionType["SnapshotsTakeOrConvert"] = "snapshots.take_or_convert";
    PermissionType["ResourcesRestore"] = "resources.restore";
    PermissionType["ConfigurationValidate"] = "configuration.validate";
    PermissionType["FilesRestore"] = "files.restore";
    PermissionType["DatabasesQuery"] = "databases.query";
    PermissionType["DataClassesOverride"] = "data_classes.override";
    PermissionType["EnvironmentsOverride"] = "environments.override";
    PermissionType["DetectedAppsOverride"] = "detected_apps.override";
    PermissionType["ControlViolationsMute"] = "control_violations.mute";
    PermissionType["BackupExclusionManage"] = "backup_exclusion.manage";
    PermissionType["VaultsManage"] = "vaults.manage";
    PermissionType["SourceAccountsManage"] = "source_accounts.manage";
    PermissionType["RestoreAccountsManage"] = "restore_accounts.manage";
    PermissionType["BackupPoliciesManage"] = "backup_policies.manage";
    PermissionType["DiscoveryConfigurationManage"] = "discovery_configuration.manage";
    PermissionType["BackupConfigurationManage"] = "backup_configuration.manage";
    PermissionType["ControlsManage"] = "controls.manage";
    PermissionType["RansomwareDetectionManage"] = "ransomware_detection.manage";
    PermissionType["NotificationPoliciesManage"] = "notification_policies.manage";
    PermissionType["StorageGatewayManage"] = "storage_gateway.manage";
    PermissionType["OauthAppsManage"] = "oauth_apps.manage";
    PermissionType["ZeroEtlPoliciesManage"] = "zero_etl_policies.manage";
    PermissionType["MpaPoliciesManage"] = "mpa_policies.manage";
    PermissionType["MpaPoliciesView"] = "mpa_policies.view";
    PermissionType["MpaRequestsManage"] = "mpa_requests.manage";
})(PermissionType || (PermissionType = {}));
